import { setModalStatus } from 'redux/slices/modal.slice';
import { setConektaPaymentAction } from 'features/payments/state/payments.slice';
import { savePendingConektaOrderId } from 'features/payments/utils/conekta-pending-order.util';
import { isRedirectMode } from 'features/payments/utils/conekta-presentation.util';
import { MODAL_NAMES } from 'utils/constants';

// ---- GUARDA LA ACCIÓN DE PAGO DE CONEKTA Y ABRE EL MODAL DE VERIFICACIÓN 3DS ----
export const handleConektaPaymentAction = paymentAction => dispatch => {
  // Fuera de Redux también, porque el componente de Conekta puede navegar la ventana
  // completa a la `return_url` y llevarse el estado. Ver conekta-pending-order.util.
  savePendingConektaOrderId(paymentAction.orderId);

  // Redirección: se abandona la app y se vuelve por `return_url`, que trae
  // `?payment_status=`. De ahí en adelante se encarga useConektaRedirectReturn,
  // que ya está montado en App.js. No se abre modal porque esta ventana deja de
  // existir tal como está.
  //
  // La orden pendiente ya quedó guardada arriba, fuera de Redux, justamente
  // para sobrevivir a esta navegación.
  if (isRedirectMode()) {
    window.location.href = paymentAction.redirectUrl;
    return;
  }

  dispatch(setConektaPaymentAction(paymentAction));
  dispatch(
    setModalStatus({
      name: MODAL_NAMES.CONEKTA_3DS,
      isActive: true,
    }),
  );
};
